import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { type LucideIcon } from "lucide-react";
import { NavLink, useMatch, useResolvedPath } from "react-router";

export type NavItem = {
  title: string;
  url: string;
  icon?: LucideIcon;
  external?: boolean;
  embedded?: boolean;
};

function NavMainItem({ item, onEmbeddedItemClick }: { item: NavItem; onEmbeddedItemClick?: () => void }) {
  const resolved = useResolvedPath(item.external ? "" : item.url);
  const match = useMatch({ path: resolved.pathname, end: true });
  const isActive = !item.external && match !== null;

  if (item.embedded) {
    return (
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip={item.title}>
          <button type="button" onClick={onEmbeddedItemClick}>
            {item.icon && <item.icon />}
            <span>{item.title}</span>
          </button>
        </SidebarMenuButton>
      </SidebarMenuItem>
    );
  }

  if (item.external) {
    return (
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip={item.title}>
          <a href={item.url} target="_blank" rel="noopener noreferrer">
            {item.icon && <item.icon />}
            <span>{item.title}</span>
          </a>
        </SidebarMenuButton>
      </SidebarMenuItem>
    );
  }

  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild tooltip={item.title} isActive={isActive}>
        <NavLink to={item.url}>
          {item.icon && <item.icon />}
          <span>{item.title}</span>
        </NavLink>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}

export function NavMain({ items, onEmbeddedItemClick }: { items: NavItem[]; onEmbeddedItemClick?: () => void }) {
  return (
    <SidebarGroup className="mt-auto border-t pt-4">
      <SidebarGroupContent className="flex flex-col gap-2">
        <SidebarMenu>
          {items.map((item) => (
            <NavMainItem key={item.title} item={item} onEmbeddedItemClick={onEmbeddedItemClick} />
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
